const services = [
  {
    icon: 'ri-gamepad-line',
    title: 'Game Design Consulting',
    description: 'In-depth analysis and guidance on game mechanics, level design, player experience, and balance. We support you at every stage — from concept to prototype, from prototype to launch.',
    highlights: ['Mechanics Design', 'UX/UI Consulting', 'Prototype Development', 'Balance Analysis'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimal%20game%20design%20workspace%20with%20concept%20art%20sketches%20on%20a%20clean%20desk%2C%20warm%20amber%20accent%20lighting%2C%20professional%20creative%20studio%20atmosphere%2C%20dark%20wooden%20desk%20surface%2C%20digital%20tablet%20with%20game%20wireframes%2C%20soft%20depth%20of%20field%2C%20editorial%20style&width=800&height=600&seq=coreloop-service-design&orientation=landscape',
  },
  {
    icon: 'ri-paint-brush-line',
    title: 'Art Direction',
    description: 'Building visual identity, art style, and production pipelines. We shape your game\'s visual world to be cohesive, compelling, and stand out in the market.',
    highlights: ['Art Style Development', 'Visual Identity Design', 'Pipeline Optimization', 'Quality Control'],
    image: 'https://readdy.ai/api/search-image?query=Artistic%20digital%20illustration%20studio%20setup%20with%20color%20palettes%20and%20mood%20boards%20displayed%20on%20a%20large%20monitor%2C%20warm%20teal%20and%20amber%20color%20scheme%2C%20creative%20workspace%20with%20drawing%20tablet%2C%20modern%20minimal%20interior%2C%20soft%20natural%20light%20from%20window%2C%20professional%20art%20direction%20environment&width=800&height=600&seq=coreloop-service-art&orientation=landscape',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Business Development',
    description: 'Market analysis, publisher relations, funding strategies, and growth planning. Strategic consulting to build a sustainable business model for your studio.',
    highlights: ['Market Analysis', 'Publisher Strategy', 'Funding Consulting', 'Growth Planning'],
    image: 'https://readdy.ai/api/search-image?query=Modern%20business%20strategy%20meeting%20room%20with%20analytics%20dashboards%20on%20screen%2C%20warm%20professional%20lighting%2C%20minimal%20wooden%20furniture%2C%20clean%20contemporary%20design%2C%20gaming%20industry%20charts%20and%20graphs%2C%20collaborative%20workspace%20atmosphere%2C%20amber%20accent%20details&width=800&height=600&seq=coreloop-service-business&orientation=landscape',
  },
];

export default function ServicesSection() {
  return (
    <section id="services" className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-3">What We Do</span>
          <h2 className="text-3xl md:text-5xl font-bold font-heading text-foreground-950 mb-4">
            Our Services
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto">
            Comprehensive consulting across the three core areas every game studio needs to thrive.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {services.map((service) => (
            <div
              key={service.title}
              className="group relative bg-background-50 border border-background-200/70 rounded-2xl overflow-hidden transition-all duration-500 hover:border-primary-200/60"
            >
              <div className="relative h-52 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-background-50/20 to-transparent"></div>
                <div className="absolute top-4 left-4 w-10 h-10 flex items-center justify-center rounded-xl bg-background-50/90 backdrop-blur-sm">
                  <i className={`${service.icon} text-xl`} style={{ color: 'oklch(var(--primary-500))' }}></i>
                </div>
              </div>

              <div className="p-6">
                <h3 className="text-xl font-bold font-heading text-foreground-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                  {service.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {service.highlights.map((h) => (
                    <span
                      key={h}
                      className="text-xs font-medium px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 whitespace-nowrap"
                    >
                      {h}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}